import {
  Avatar,
  Button,
  Checkbox,
  DialogContent,
  DialogTitle,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  makeStyles,
  Typography
} from "@material-ui/core";
import { Delete as DeleteIcon } from "@material-ui/icons";
import classNames from "classnames";
import moment from "moment";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Link as RouterLink } from "react-router-dom";
import { dateTimeInterval } from "../ducks/utils";
import { DeleteDialog } from "./index";

const useStyles = makeStyles(theme => ({
  meetingSlotRow: {
    color: "black",
    backgroundColor: "#cdcdcd",
    borderRadius: "0.5rem",
    margin: "0.25rem 0",
    "& > *": {
      marginRight: "1rem"
    }
  },
  meetingSlotRowDisabled: {
    "& > :not(:first-child)": {
      opacity: "0.5"
    },
    backgroundColor: "#dedede"
  },
  meetingSlotRowSelected: {
    backgroundColor: "#eaf1ff"
  },
  meetingSlotRowBooked: {
    backgroundColor: "white"
  },
  meetingSlotRowPast: {
    "& > *": {
      color: "grey",
      textDecoration: "line-through"
    }
  },
  meetingSlotBody: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flex: "1 1",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column"
    },
    "& > *": {
      marginRight: "1rem"
    }
  },
  time: {
    "& > strong": {
      color: "#0a0a2d"
    },
    "& > span": {
      marginLeft: "1.2em"
    }
  },
  text: {
    textAlign: "center"
  }
}));

const MeetingListItem = ({
  meetingSlot,
  meeting,
  profile,
  selected = false,
  onDelete = () => {},
  onSelect = false
}) => {
  const intl = useIntl();
  const classes = useStyles();

  const isPast = moment(meetingSlot.endAt).isBefore();

  const [deleteMeetingDialogOpen, setDeleteMeetingDialogOpen] = useState(false);

  const onDeleteMeetingDialogOpen = () => {
    setDeleteMeetingDialogOpen(true);
  };
  const onDeleteMeetingDialogClose = () => {
    setDeleteMeetingDialogOpen(false);
  };

  return (
    <ListItem
      key={meetingSlot.id}
      className={classNames(classes.meetingSlotRow, {
        [classes.meetingSlotRowSelected]: selected,
        [classes.meetingSlotRowDisabled]: !meetingSlot.available,
        [classes.meetingSlotRowBooked]: meetingSlot.meeting,
        [classes.meetingSlotRowPast]: isPast
      })}
    >
      <ListItemIcon>
        {onSelect && (
          <Checkbox
            checked={selected}
            onClick={onSelect({ meetingSlot })}
            color="primary"
            disabled={!!meetingSlot.meeting || isPast}
          />
        )}
      </ListItemIcon>

      <div className={classes.meetingSlotBody}>
        <Typography className={classes.time}>
          <strong>{dateTimeInterval(meetingSlot.startAt, meetingSlot.endAt, false)}</strong>
        </Typography>
        {meeting ? (
          <>
            <Avatar src={profile?.avatarThumb} />
            <span className={classes.text}>{`${profile.firstName} ${profile.lastName}`}</span>
            {!isPast && (
              <Button
                color="primary"
                variant="outlined"
                size="small"
                component={RouterLink}
                to={`/meetings/${meeting.roomName}?token=${meeting.token}`}
                disabled={isPast}
              >
                {intl.formatMessage({
                  id: "Pages.MeetingSchedulerPage.JoinMeeting",
                  defaultMessage: "Join Meeting"
                })}
              </Button>
            )}
          </>
        ) : (
          <span>
            {meetingSlot.available
              ? intl.formatMessage({
                  id: "Pages.MeetingSchedulerPage.Available",
                  defaultMessage: "Available"
                })
              : intl.formatMessage({
                  id: "Pages.MeetingSchedulerPage.NotAvailable",
                  defaultMessage: "Not Available"
                })}
          </span>
        )}
      </div>

      <ListItemSecondaryAction>
        {!isPast && meeting && (
          <>
            <IconButton onClick={onDeleteMeetingDialogOpen}>
              <DeleteIcon />
            </IconButton>
            {deleteMeetingDialogOpen && (
              <DeleteDialog
                id={meeting.id}
                onDelete={onDelete({ id: meeting.id })}
                onClose={onDeleteMeetingDialogClose}
              >
                <DialogTitle>
                  {intl.formatMessage({
                    id: "Shared.MeetingListItem.DeleteDialog.Title",
                    defaultMessage: "Are you sure you want to cancel this meeting?"
                  })}
                </DialogTitle>
                <DialogContent>
                  <Typography variant="body2">
                    {intl.formatMessage({
                      id: "Shared.MeetingListItem.DeleteDialog.Message",
                      defaultMessage: "Other user will be notified of the meeting cancel."
                    })}
                  </Typography>
                </DialogContent>
              </DeleteDialog>
            )}
          </>
        )}
      </ListItemSecondaryAction>
    </ListItem>
  );
};
export default MeetingListItem;
